export default function WeekRangeBar({
  top,
  leftPercent,
  widthPercent,
  backgroundColor,
  label,
  onClick,
  title,
  className = '',
  tinted = false,
  colorRgbVar,
}) {
  const tintedStyle = tinted && colorRgbVar
    ? {
      backgroundColor: `rgb(var(--${colorRgbVar}) / 0.16)`,
      borderColor: `rgb(var(--${colorRgbVar}) / 0.6)`,
      color: `rgb(var(--${colorRgbVar}))`,
    }
    : { backgroundColor };

  return (
    <button
      type="button"
      onClick={onClick}
      className={`absolute mt-2 h-8 rounded-md text-xs px-4 border hover:opacity-80 flex items-center gap-2 overflow-hidden transition-opacity ${tinted ? 'font-medium' : 'text-white border-white/20'} ${className}`}
      style={{
        top,
        left: `calc(${leftPercent}% + 4px)`,
        width: `calc(${widthPercent}% - 8px)`,
        ...tintedStyle,
      }}
      title={title}
    >
      <span className="truncate">{label}</span>
    </button>
  );
}
